export const ACTION_LOGIN = 'ACTION_LOGIN'
export const ACTION_LOGOUT = 'ACTION_LOGOUT'
export const ACTION_REGISTER = 'ACTION_REGISTER'
export const ACTION_RESET_PASSWORD = 'ACTION_RESET_PASSWORD'

export const SET_LOGGED_USER = 'SET_LOGGED_USER'

export const LOGGED_USER_KEY = 'loggedUser'
export const PROFILE_KEY = 'profile'
